// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nul.event-list li {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  float: left;\r\n  justify-content: space-betweeen;\r\n  list-style: none;\r\n  margin: 10px;\r\n  padding: 10px;\r\n  width: 125px;\r\n  background-color: rgb(26, 99, 26);\r\n  color: white;\n}\n.label {\r\n  font-weight: bolder;\r\n  float: left;\n}\n.value {\r\n  float:right;\n}\r\n", ""]);
// Exports
module.exports = exports;
